/*
 * Module for the Standard Response publish modal
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "underscore",
  "./standardResponsePublishModalView",
  "modules/shared/treeList/treeListModule",
  "modules/shared/treeList/treeListModel",
  "modules/topicsSplit/topic/topicResponse/topicResponseModel",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  Backbone,
  Messenger,
  _,
  StandardResponsePublishModalView,
  TreeListModule,
  TreeListModel,
  TopicResponseModel,
  KbMenuModel,
) {
  var StandardResponsePublishModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "standardResponsePublishModal";
    },
    show: function (standardResponse) {
      this.touchPoints = Messenger.reqres.request("kb:touchpoints");
      this.locales = Messenger.reqres.request("kb:languages");
      this.layout = new StandardResponsePublishModalView.standardResponsePublishModalLayout();
      this.root = this._buildModel(standardResponse, this.touchPoints, this.locales);
      this.pendingResponsesList = this.addSubModule(
        new TreeListModule({
          region: this.layout.pendingResponseList,
          namespace: this.name,
        }),
      );

      this.layout.on(
        "done",
        function () {
          this.layout.hideError();
          var selectedResponses = Messenger.reqres.request(this.name + ":treeList:selected:nodes");
          if (selectedResponses.length === 0) {
            this.layout.hideWarning();
            //no pending responses selected
            this.layout.showError();
          } else {
            standardResponse.selectedResponses = selectedResponses;
            Messenger.vent.trigger("standardResponses:publish:pending:responses");
            Messenger.vent.trigger("close:modal");
          }
        },
        this,
      );
      this.layout.on(
        "cancel",
        function () {
          this.layout.hideError();
          Messenger.vent.trigger("standardResponses:cancel:pending:responses");
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.layout.on(
        "selectAll",
        function () {
          Messenger.vent.trigger(this.name + ":treeList:select:all");
        },
        this,
      );
      this.layout.on(
        "deselectAll",
        function () {
          Messenger.vent.trigger(this.name + ":treeList:deselect:all");
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this.layout.hideError();
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _buildModel: function (standardResponse, touchPoints, locales) {
      var pendingResponseTemplates = this._findPendingResponseTemplates(standardResponse);
      this.treeData = [];

      locales.forEach(function (locale) {
        var node = {
          name: locale.get("name"),
          data: locale.get("id"),
          nodes: [],
        };
        var localeId = locale.get("id");
        touchPoints.forEach(
          function (touchPoint) {
            var pendingResponseTemplate;
            var touchPointId = touchPoint.get("touchPointId");
            if (pendingResponseTemplates) {
              pendingResponseTemplate = _.find(pendingResponseTemplates, function (template) {
                return (
                  template.get("touchpointId") == touchPointId &&
                  template.get("languageId") == localeId
                );
              });
            }
            if (pendingResponseTemplate) {
              this.nodes.push({
                name: touchPoint.get("touchPoint"),
                data: localeId + "_" + touchPointId,
              });
            }
          },
          { nodes: node.nodes },
        );

        if (node.nodes.length > 0) {
          this.treeData.push(node);
        }
      }, this);
      return new TreeListModel.collection(this.treeData);
    },
    _findPendingResponseTemplates: function (standardResponse) {
      var liveResponseTemplates = standardResponse.liveResponse.responseTemplates();
      var pendingResponseTemplates = standardResponse.responseTemplates();

      var result = [];
      if (liveResponseTemplates.length === 0 && pendingResponseTemplates.length > 0) {
        result = pendingResponseTemplates.filter(function (response) {
          return !response.isEmpty();
        });
      } else if (liveResponseTemplates.length > 0 && pendingResponseTemplates.length > 0) {
        result = pendingResponseTemplates.filter(function (pendingResponseTemplate) {
          // Find the corresponding live response
          var liveResponseTemplate = liveResponseTemplates.findWhere({
            touchpointId: pendingResponseTemplate.get("touchpointId"),
            languageId: pendingResponseTemplate.get("languageId"),
          });

          if (!liveResponseTemplate) {
            // Don't publish blank pending responses that don't have a corresponding live response
            return !pendingResponseTemplate.isEmpty();
          } else {
            // Only publish pending responses that are different from the live versions
            return liveResponseTemplate.get("response") != pendingResponseTemplate.get("response");
          }
        });
      }

      return result;
    },
    _showSubViews: function () {
      this.pendingResponsesList.show({ model: this.root });
    },
  });

  return StandardResponsePublishModalController;
});
